import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=65c5702c&"
import script from "./DatePicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c5702c')) {
      api.createRecord('65c5702c', component.options)
    } else {
      api.reload('65c5702c', component.options)
    }
    module.hot.accept("./DatePicker.vue?vue&type=template&id=65c5702c&", function () {
      api.rerender('65c5702c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/DatePicker.vue"
export default component.exports